module.exports = __webpack_public_path__ + "static/media/halo-auto.cb054781.svg";